import { render, staticRenderFns } from "./userAvatar.vue?vue&type=template&id=1f51b766&"
import script from "./userAvatar.vue?vue&type=script&lang=js&"
export * from "./userAvatar.vue?vue&type=script&lang=js&"
import style0 from "./userAvatar.vue?vue&type=style&index=0&id=1f51b766&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports